<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="flex mb-3" style="flex-direction: column">
          <div class="vx-col w-full mb-3">
            <router-link
              :to="{ path: '/CheckInTransactions/Create' }"
              class="vs-component vs-button bg_l_green vx-col"
              v-has-permission="permission113"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("CreateCheckInTransactions") }}
            </router-link>
            <router-link
              :to="{
                path: '/CheckInTransactions/CreateCheckInForReturnCheckOut',
              }"
              class="vs-component vs-button bg_l_green mx-4"
              v-has-permission="permission313"
            >
              <feather-icon
                icon="PlusIcon"
                svgClasses="h-4 w-4"
                class="ico"
              />{{ $t("CreateCheckInForReturnCheckOut") }}
            </router-link>
          </div>
          <div style="display:flex" v-has-permission="'CheckInWithExcelFile|UpdateTrackingIdWithExcelFile'" class="vx-col w-full">
            <div
              v-has-permission="'CheckInWithExcelFile'"
              class="flex vx-col mb-2"
              style="gap: 10px;width:50%"
            >
              <div
                class="vx-col"
                style="
                  display: flex;
                  align-items: center;
                  width: calc(100% - 120px);
                 max-width: calc(100% - 120px);
                "
              >
                <label
                  class="custom-file-upload"
                  style="
                    width: 100%;
                    margin-top: 10px;
                    padding-top: 9px;
                    height: 40px;
                    display: flex;
                    border-radius: 4px;
                  "
                >
                  <input
                    type="file"
                    id="file"
                    ref="file"
                    :clearable="false"
                    @change="handleFileUpload()"
                  />
                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                    style="margin-bottom: 11px; margin-left: 6px"
                  />
                  {{ defualtPlaceHolderOfCheckIn }}
                  <span v-if="uploadedFileName" class="file-name">{{
                    uploadedFileName
                  }}</span>
                </label>
              </div>
              <div
                class="vx-col"
                style="
                  width: 120px;
                  display: flex;
                  align-items: center;
                  margin-top: 10px;
                "
              >
                <vs-button
                  @click="uploadFile()"
                  class="bg_m_green"
                  style="height: 40px"
                  :disabled="isDisabled"
                  v-has-permission="permission112"
                >
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                آپلود فایل
                </vs-button>
              </div>
            </div>
            <div v-has-permission="'UpdateTrackingIdWithExcelFile'" class="flex vx-col mb-2" style="gap: 10px;width:50%;">
              <div
                class="vx-col"
                style="
                  display: flex;
                  align-items: center;
                  width: calc(100% - 120px);
                  max-width: calc(100% - 120px);
                "
              >
                <label
                  class="custom-file-upload"
                  style="
                    width: 100%;
                    margin-top: 10px;
                    padding-top: 9px;
                    height: 40px;
                    display: flex;
                    border-radius: 4px;
                  "
                >
                  <input
                    type="file"
                    id="updateTrackingIdFile"
                    ref="updateTrackingIdFile"
                    :clearable="false"
                    @change="handleFileUploadForUpdateTrackingId()"
                  />

                  <feather-icon
                    icon="PaperclipIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                    style="margin-bottom: 11px; margin-left: 6px"
                  />
                  {{ defualtPlaceHolderOfUpdateTrackingId }}
                  <span v-if="uplodedTrackingIdFileName" class="file-name">{{
                    uplodedTrackingIdFileName
                  }}</span>
                </label>
              </div>
              <div
                class="vx-col"
                style="
                  width: 120px;
                  display: flex;
                  align-items: center;
                  margin-top: 10px;
                "
              >
                <vs-button
                  @click="uploadFileForUpdateTrackingId()"
                  class="bg_m_green"
                  style="height: 40px"
                  :disabled="isDisabledUpdateTrachingIdBtn"
                >
                  <feather-icon
                    icon="PlusIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  آپلود فایل
                </vs-button>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('WarehouseName'), sort: 'WarehouseName' },
                { title: $t('Applicant'), sort: 'Applicant' },
                { title: $t('InventoryTransactionId') },
                { title: $t('ShipmentNumber') },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 15%">
                  {{ row.storeInfoQuery.storeInfoName }}
                </td>
                <td style="width: 15%">
                  {{ row.inventoryOperatorQuery.inventoryOperatorName }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.id }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.shipmentNumber }}
                </td>
                <td style="width: 15%; direction: ltr">
                  {{ row.createOn.split("   ")[0] }}<br />{{
                    row.createOn.split("   ")[1]
                  }}
                </td>
                <td style="width: 25%">
                  <router-link
                    :to="{ path: '/CheckInTransactions/Details/' + row.id }"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="view-details"
                      >{{ $t("ViewDetails") }}</vs-button
                    >
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}
.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 4px 12px 4px 12px;
  cursor: pointer;
  float: left;
}

.bg_m_green {
  padding: 0.3rem 0.8rem !important;
}

.file-name {
  padding: 0 0.5rem;
  background-color: #eeeff1;
  position: relative;
  left: -0.65rem;
  // max-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  direction: ltr;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import { mapActions } from "vuex";
import vSelect from "vue-select";

export default {
  name: "warehouseManagement_CheckinTransactions_Index",
  components: {
    DataGrid,
    "v-select": vSelect,
  },
  data() {
    return {
      permission112: "CheckInWithExcelFile",
      permission113: "RegisterCheckIn",
      permission313: "CheckInForReturnCheckOut",
      permission114:
        "GetInventoryTransactionItemsByInventoryTransaction|GetInventoryTransactionHeader",
      ModifyPopup: false,
      modalModel: {},
      defualtPlaceHolderOfCheckIn: "انتخاب فایل برای صدور رسید ورود",
      defualtPlaceHolderOfUpdateTrackingId: "انتخاب فایل برای به روز رسانی شناسه رهگیری",
      gridDataSource: {
        type: "app",
        service: "Inventory/api/CheckinTransactionsQuery",
      },
      gridSearchData: {
        keyword: "",
      },
      file: "",
      fileUploaded: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
      updateTrackingIdFile: "",
      uplodedTrackingIdFileName: "",
      updateTrackingIdEmptyFileInRefs: "",
    };
  },
  computed: {
    isDisabled: function () {
      if (this.file) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledUpdateTrachingIdBtn: function () {
      if (this.updateTrackingIdFile) {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
    this.updateTrackingIdEmptyFileInRefs =
      this.$refs.updateTrackingIdFile.files;
  },
  methods: {
    ...mapActions({
      importCheckInExcel: "excel/importCheckInExcel",
      uploadFileToUpdateTheTrackingId: "excel/uploadFileToUpdateTheTrackingId",
    }),
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.$refs.file.files[0].name;
      this.fileUploaded = true;
      this.defualtPlaceHolderOfCheckIn = "";
    },
    handleFileUploadForUpdateTrackingId() {
      this.updateTrackingIdFile = this.$refs.updateTrackingIdFile.files[0];
      this.uplodedTrackingIdFileName =
        this.$refs.updateTrackingIdFile.files[0].name;
      this.defualtPlaceHolderOfUpdateTrackingId = "";
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
      this.defualtPlaceHolderOfCheckIn = "انتخاب فایل برای صدور رسید ورود";
    },

    removeUploadTrackingIdFile() {
      this.updateTrackingIdFile = "";
      this.$refs.updateTrackingIdFile.files =
        this.updateTrackingIdEmptyFileInRefs;
      this.uplodedTrackingIdFileName = "";
      this.defualtPlaceHolderOfUpdateTrackingId =  "انتخاب فایل برای به روز رسانی شناسه رهگیری";
    },
    uploadFile() {
      let formData = new FormData();
      formData.append("file", this.file);
      this.importCheckInExcel(formData).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
      }, 1000);
    },
    uploadFileForUpdateTrackingId() {
      let formData = new FormData();
      formData.append("file", this.updateTrackingIdFile);
      this.uploadFileToUpdateTheTrackingId(formData).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadTrackingIdFile();
      }, 1000);
    },
  },
};
</script>
